<template>
  <div id="page-usuarios" data-app>
    <div>
      <v-breadcrumbs :items="breadcrumbs" >
        <v-icon slot="divider" >forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
           <base-material-card
          color="primary"
          icon="library_books"
          title="Reporte de Embarques"
          class="elevation-1 px-5 py-3"
        >
            <v-card-actions>
            
              <v-spacer></v-spacer>

            </v-card-actions>
            <v-card-text>

              <!-- Buscador -->
              <v-form ref="form" lazy-validation>
              <v-container fluid fill-height>
                <v-layout wrap>
                  <v-flex s12 m6 l6>
                      <v-text-field
                        label="Búsqueda General"
                        v-model="busqueda"
                      ></v-text-field>
                  </v-flex>
                  <v-flex s12 m4 l4>
                        <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                                <v-text-field v-on="on" v-model="fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fecha_de = parseDate(fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                <v-spacer />

                                <v-btn color="secondary" x-small @click="menu1 = false" >
                                    Cancelar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex s12 m4 l4>
                        <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                                <v-text-field v-on="on" v-model="fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fecha_a= parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                                <v-spacer />

                                <v-btn color="secondary" x-small @click="menu2 = false" >
                                    Cancelar
                                </v-btn>
                            </v-date-picker>
                        </v-menu>                      
                    </v-flex>
                  </v-layout>                  
              </v-container>
              </v-form>
              </v-card-text>

              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click.native="busquedaGeneral()" >
                          <v-icon>search</v-icon>Buscar
                        </v-btn>                    
                        <v-btn color="default" @click.native="limpiaBusquedaGeneral()" >
                          <v-icon>block</v-icon>Limpiar
                        </v-btn>                  
              </v-card-actions>

              <v-card-text>
              <!-- Importador -->
              <v-flex xs12 style="margin-top: 50px" justify-end row fill-height>
                <v-speed-dial  direction="left" open-on-hover>
                       <template v-slot:activator>
                          <v-btn   x-small      fab    dark      color="primary"  >
                        	<v-icon>reorder</v-icon>
                      	</v-btn>
                      </template>
                  <exportar-excel
                    :data="datafiltered"
                    :exportFields="traficos.fieldsExcel"
                    name="Tráficos.xlsx"
                  >
                    <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                      <v-icon dark>get_app</v-icon>
                    </v-btn>
                  </exportar-excel>
                </v-speed-dial>
              </v-flex>              

              <v-client-table
                ref="vuetable"
                :data="traficos.items"
                :columns="columns"
                :options="options"
                class="elevation-2 pa-2" >
                <template slot="noResults" >
                  <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                </template>

                <template slot="mensaje" slot-scope="props" >
                    <span v-if="props.row.mensaje != ''" >
                        {{ props.row.mensaje }}
                    </span>
                    <span v-else>
                        ......
                    </span>
                </template>

              </v-client-table>
              
            </v-card-text>
          </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>

   

  </div>
</template>

<script>
import axios from "axios";
import {ServerTable, ClientTable, Event} from 'vue-tables-2';
import moment from "moment";

export default {
  computed:{
    datafiltered(){
      if (this.$refs.vuetable != null)   {
        return this.$refs.vuetable.allFilteredData;
      }
      else{
        return this.traficos.items;
      }

    },
  },
  mounted() {
    this.getColumnsTabs();
    this.getTraficos();
  },
  data() {
    return { fab: false,
      name: "datagrid",
      
      show_loading: true,
      menu1: false,
      menu2: false,
      columns: ["responsable_trafico",  "referencia", "tipo_operacion", "embarcador", "consignatario","tipo_embarque", "modalidad_transporte", "mensaje", "estado", "actions"],
      options: {
        filterable: ["responsable_trafico",  "referencia", "tipo_operacion", "embarcador", "consignatario","tipo_embarque", "modalidad_transporte", "mensaje", "estado"],
        sortable: ["referencia", "responsable_trafico",  "referencia", "tipo_operacion", "fecha_recoleccion", "embarcador", "consignatario","tipo_embarque", "modalidad_transporte", "mensaje", "estado"],

        headings: {},

        orderBy: { column: "referencia", ascending: false },

        customFilters: [{
            name: 'referenciaGeneral',
            callback: function (row, query) {
                return row.referencia == query;
            }
        }]
      },
      breadcrumbs: [
        {
            text: "Inicio",
            disabled: false,
            to: "/trafico_index"
        },
        {
          text: "Reportes",
          disabled: false,
          to: ""
        },
        {
          text: "Gestión de Embarques",
          disabled: false,
          to: ""
        }
      ],
      search: "",
      traficos: {
        items: [],
        itemsCopy: [],
        fieldsExcel: {}
      },
      rules: {
          required: v => !!v || 'Este campo es requerido',
      },
      busqueda: '',
      //fecha_inicio_modal: false,
      //fecha_inicio_formated: '',      
      fecha_de: "",
      fecha_a: "",      
      //fecha_fin_modal: false,
      //fecha_fin_formated: '',      
      resultadoBusqueda: [],
    };
  },  
  methods: {
    validaFecha: function(fecha){        
        if (fecha == "Invalid date")
            return "Fecha no válida."
    },
    validaAnio: function(){            
          if (this.fecha_de != "" && this.fecha_a != ""){
              var inicio = moment(this.fecha_de, "YYYY-MM-DD");
              var fin = moment(this.fecha_a, "YYYY-MM-DD");
              var diferencia = fin.diff(inicio, 'days')     
              if (diferencia < 0)
                  return "La Fecha Final no debe ser menor a la Fecha Inicial."              
          }
          return true;
      },        
      parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
    formatDate (date) {
        if (!date) return null;

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`;
    },
    invertDate(date) {
        if (!date) return null

        const [day, month, year] = date.split('/')

        return `${year}-${month}-${day}`;
    },

    getTraficos: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let rfc = this.$local_storage.get("rfc");
      let data = { rfc: rfc };

      axios
        .post(this.$hostname + "traficos/listado/", data)
        .then(response => {

          if (typeof response.data !== "undefined") {
            //console.log(response.data.results);

            this.traficos.items = response.data.results;
            this.formatTable();
          }

          this.$root.$dialogLoader.hide();
        })
        .catch(error => {
          console.log(error);
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los tráficos.",
            footer: ""
          });
        });
    },
    formatTable: function() {
        for(var k in this.traficos.items) {

                // Embarques y Consignatarios                
                if (this.traficos.items[k].embarques != undefined){
                  var embarques = this.traficos.items[k].embarques[0];

                  if(embarques.especificaciones != undefined){
                    var especificaciones = embarques.especificaciones[0];
                    this.traficos.items[k]['embarcador'] = especificaciones.emisor + " " + especificaciones.embarcador;

                    this.traficos.items[k]['consignatario1'] = especificaciones.consignatario1;

                  }
                }else{
                  this.traficos.items[k].embarcador= ' ';
                  this.traficos.items[k]['consignatario1'] = ' ';
                }

                // Estado y Mnesaje
                if(this.traficos.items[k].movimientos.length > 0){
                  this.traficos.items[k].subestado = this.traficos.items[k].movimientos[this.traficos.items[k].movimientos.length -1].subestado;

                  let nota = this.traficos.items[k].movimientos[this.traficos.items[k].movimientos.length -1].nota;

                  if(nota && nota.length > 0){
                    let ultimaNota = nota[nota.length -1];
                    this.traficos.items[k].mensaje = ultimaNota.nota;
                  }else
                    this.traficos.items[k].mensaje = '';
                }

                // HBL
                this.traficos.items[k].referencia_hbl = this.traficos.items[k].referencia_hbl + ' ' + this.traficos.items[k].booking;
                this.traficos.items[k].detalles_totales = this.traficos.items[k].detalles_carga;

                // Contenedor
                this.traficos.items[k].detalles_carga = this.traficos.items[k].detalles_carga.length;
                if (this.traficos.items[k].detalles_carga > 0) {
                  this.traficos.items[k].numero_contenedor =  this.traficos.items[k].detalles_totales[0].numero_contenedor;
                }

                // Agentes
                this.traficos.items[k].aduana_despacho = this.traficos.items[k].aduana_despacho.clave; //aduana despacho clave
                this.traficos.items[k].agente_aduanal = this.traficos.items[k].agente_aduanal.nombre; //agente aduanal nombre

                // Fechas
                if (this.traficos.items[k].fecha_embarque){
                  this.traficos.items[k].fecha_embarque_no_format = this.traficos.items[k].fecha_embarque.substr(0, 10)
                  this.traficos.items[k].fecha_embarque = this.formatDate(this.traficos.items[k].fecha_embarque.substr(0, 10))
                }
                if (this.traficos.items[k].fecha_llegada){
                  this.traficos.items[k].fecha_llegada_no_format = this.traficos.items[k].fecha_llegada.substr(0, 10)
                  this.traficos.items[k].fecha_llegada = this.formatDate(this.traficos.items[k].fecha_llegada.substr(0, 10))
                }
            }
    },
    getColumnsTabs: function() {
      let idCliente = this.$local_storage.get("id_cliente");

      axios
        .post(this.$hostname + "catalogos/estados_trafico/list_columnas/", {"cliente": idCliente})
        .then(response => {
          //console.log(response);
            let camposColumna = response.data.filter((columna) => {
                return columna.visible == true && columna.campo != null && columna.header != null ;
            });
            
            this.columns = [];
            this.traficos.fieldsExcel = {};
            this.options.headings = {};

            for (var i = 0; i < camposColumna.length; i++){  
              if (!this.columns.includes(camposColumna[i].campo) ) {
                this.columns.push(camposColumna[i].campo);
                this.options.headings[camposColumna[i].campo] = camposColumna[i].header;

                this.traficos.fieldsExcel[camposColumna[i].header] = camposColumna[i].campo;
              }
            }

            this.traficos.itemsCopy = this.traficos.items

        }).catch(error => {
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener las columnas.",
            footer: ""
          });
        });
    },
    busquedaGeneral: function() {

        if (this.busqueda != '') {
          var rfc = this.$local_storage.get("rfc");

          let data = {
            "rfc": rfc,
            "texto": this.busqueda
          };
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

          axios
              .post(this.$hostname + "traficos/search/", data, {
                  "Content-type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                  "cache-control": "no-cache"
                })
              .then(response => {
                  this.resultadoBusqueda = [];

                  if (response.data.length > 0){
                    this.traficos.items = response.data;
                    this.formatTable();
                  }
                  else
                    this.$swal({
                      type: "info",
                      title: "Aviso",
                      text: "No se econtraron tráficos en la busqueda",
                      footer: ""
                    });
              })
              .catch(error => {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al obtener el tráfico",
                  footer: ""
                });
              })
              .then(() => {
                  this.$root.$dialogLoader.hide();
              });

        }else if (this.fecha_de != '' || this.fecha_a != '') {
            let fecha_inicio = this.$moment(this.fecha_de);
            let fecha_fin = this.$moment(this.fecha_a);
            this.traficos.items = this.traficos.itemsCopy;
            

            if (this.fecha_de != '' && this.fecha_a == '') {

                this.traficos.items = this.traficos.items.filter((trafico) => {
                    if (trafico.fecha_embarque_no_format == null)
                      return false

                    let fecha_embarque_no_format = this.$moment(trafico.fecha_embarque_no_format.substr(0, 10));

                    return fecha_inicio.isSameOrBefore(fecha_embarque_no_format);
                });
            }else if (this.fecha_de == '' && this.fecha_a != '') {

                this.traficos.items = this.traficos.items.filter((trafico) => {
                    if (trafico.fecha_embarque_no_format == null)
                      return false

                    let fecha_embarque_no_format = this.$moment(trafico.fecha_embarque_no_format.substr(0, 10));

                    return fecha_fin.isSameOrAfter(fecha_embarque_no_format);
                });

            }else{

                this.traficos.items = this.traficos.items.filter((trafico) => {
                  if (trafico.fecha_embarque_no_format == null)
                      return false

                  let fecha_embarque_no_format = this.$moment(trafico.fecha_embarque_no_format.substr(0, 10));
                  
                  return fecha_inicio.isSameOrBefore(fecha_embarque_no_format) && fecha_fin.isSameOrAfter(fecha_embarque_no_format);
                });
            }




        }else
            this.$swal({
                  type: "info",
                  title: "Cuidado",
                  text: "Ingrese datos para la busqueda",
                  footer: ""
                });

    },
    limpiaBusquedaGeneral: function() {
      this.busqueda = '';
      this.resultadoBusqueda = [];
      this.getTraficos();
    },
  }
};

</script>
